export default __webpack_public_path__ + "static/media/twitter-small.b3ed6037.svg";